// Auto-generated normalizer for table: CAR_BOOKING.DiasFestivosInhabilies
export function diasFestivosInhabiliesNormalize(row) {
  return {
    idDiaFestivo: row.idDiaFestivo ?? row.IdDiaFestivo ?? row['idDiaFestivo'] ?? 0,
    fechaFestiva: row.fechaFestiva ?? row.FechaFestiva ?? row['fechaFestiva'] ?? null,
    descripcion: row.descripcion ?? row.Descripcion ?? row['descripcion'] ?? '',
    esRecurrente: row.esRecurrente ?? row.EsRecurrente ?? row['esRecurrente'] ?? '',
    esFindeSemana: row.esFindeSemana ?? row.EsFindeSemana ?? row['esFindeSemana'] ?? '',
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['fechaCreacion'] ?? null,
    diaAplicacion: row.diaAplicacion ?? row.DiaAplicacion ?? row["diaAplicacion"] ?? '',
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? row['IdEmpresa'] ?? null,
  };
}